import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "FlexVideoPlayer",
    component: () => (__SERVER__ ? require("./flex-video-player-view") : import("./flex-video-player-view"))
});

export default definition;
